import { render } from "./config-voltage-alarms.vue?vue&type=template&id=3105d49b&scoped=true"
import script from "./config-voltage-alarms.vue?vue&type=script&lang=js"
export * from "./config-voltage-alarms.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3105d49b"

export default script